<script setup>
/* Imports */
import { createProductOptions, provideProductOptions } from '@garmin/ui-product-ems-filters';
import { convertBootstrapData } from './data-comparison/convertBootstrapData.js';
import { diffEmsData } from './data-comparison/diffEMSData.js';
import { cleanData } from './data-comparison/cleanData.js';

/* Product options composable
 * Provide a shared instance to all descendant components and seed it from
 * window.emsData (filter dropdown, options list, and per-SKU
 * enabled/disabled/selected state) using window.GarminAppBootstrap for the
 * currently selected SKU so useProductOptions() consumers have data on first
 * render.
 */
const bootstrap = window?.GarminAppBootstrap ?? {};
const emsData = window?.emsData ?? {};

const productOptions = createProductOptions();
productOptions.setFilterDropdownList(emsData?.filterDropDown ?? []);
productOptions.setProductOptions({
  optionsList: emsData?.emsDetails ?? [],
  options: emsData?.skuVariantMatrix?.[bootstrap?.sku] ?? {},
});

provideProductOptions(productOptions);

// EMS TODO - Remove once we confirm new EMS API is returning correct data
if (window?.envSettings?.ITFE_PRODUCT_PAGE_ENABLE_REUSABLE_EMS_UI) {
  window.convertedBootstrapData = cleanData(convertBootstrapData(bootstrap));
  window.emsDataCopy = cleanData(JSON.parse(JSON.stringify(emsData)));
  diffEmsData(window.convertedBootstrapData, window.emsDataCopy);
}
</script>

<template>
  <RouterView />
</template>
